<template>
  <FrameMobile>
    <template v-slot:header>
      <GeneralHeaderMobile :headerBackground="headerBackground" :title="title" />
    </template>
    <template v-slot:content>
      <NotificationList />
    </template>
    <template v-slot:footer>
      <FooterMobile :currentItem="currentFooterItem" />
    </template>
  </FrameMobile>
</template>

<script>
import FooterMobile from '@/components/FooterMobile.vue';
import FrameMobile from '@/components/mcf/FrameMobile.vue';
import GeneralHeaderMobile from '@/components/mcf/GeneralHeaderMobile.vue';
import NotificationList from '@/components/notification/NotificationList.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  components: {
    FooterMobile,
    FrameMobile,
    GeneralHeaderMobile,
    NotificationList,
  },
  data() {
    return {
      // 標題
      title: '',
      // header背景圖
      headerBackground: '',
      // 當前頁尾項目
      currentFooterItem: 'MemberCentreHomePage',
    };
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getPageSetting', 'Notification')
      .then((setting) => {
        // 標題
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = title;
        vm.title = title;
        // header背景
        vm.headerBackground = setting.backgroundMobilePic;
      });
  },
};
</script>
